const translations = {
  'blog.seo.title': 'Blog About Teaching English and Life in Barcelona & Seville',
  'blog.seo.description':
    'Weekly posts on life as an English teacher in Barcelona & Seville. Including teaching tips, free events and informative articles about local culture.',
};

export default translations;
